import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'decision-maker-cell',
  templateUrl: './decision-maker-cell.component.html',
  styleUrl: './decision-maker-cell.component.scss',
  standalone: false,
})
export class DecisionMakerCellComponent implements ICellRendererAngularComp {
  params: any;

  constructor() {}

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params.data;
    return true;
  }
}
